/**
 * @fileOverview the entry of coordinate
 * @author sima.zhang1990@gmail.com
 */
var Coord = require('./base');

Coord.Cartesian = require('./cartesian');
Coord.Rect = Coord.Cartesian;
Coord.Polar = require('./polar');
Coord.Helix = require('./helix');
module.exports = Coord;


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 7
// module chunks = 0